import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";


export default function FAQAccordion({ items, testIdPrefix = "faq" }) {
    const [openIdx, setOpenIdx] = useState(-1);

    return (
        <div className="divide-y divide-charcoal/10 border-y border-charcoal/10" data-testid={`${testIdPrefix}-accordion`}>
            {items.map((item, i) => {
                const open = openIdx === i;
                const id = `faq-panel-${i}`;
                return (
                    <div key={i}>
                        <button
                            className="w-full flex items-center justify-between text-left py-5 md:py-6 gap-6 group"
                            aria-expanded={open}
                            aria-controls={id}
                            onClick={() => setOpenIdx(open ? -1 : i)}
                            data-testid={`${testIdPrefix}-question-${i}`}
                        >
                            <span className="font-manrope font-semibold text-charcoal text-[16.5px] md:text-[18px] leading-snug pr-4">{item.q}</span>
                            <Plus size={20} className={"shrink-0 text-charcoal/70 transition-transform duration-200 " + (open ? "rotate-45 text-terracotta" : "rotate-0 group-hover:text-terracotta")} />
                        </button>
                        <div id={id} className={"grid transition-all duration-200 ease-out " + (open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0")}>
                            <div className="overflow-hidden">
                                <div className="pb-6 pr-8 md:pr-16 text-charcoal/75 font-inter text-[15.5px] md:text-[16px] leading-relaxed space-y-3">
                                    {item.a.split(/\n\n+/).map((para, idx) => (
                                        <p key={idx}>{para}</p>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}


export function HomepageFAQ({ items }) {
    return (
        <section id="faqs" className="bg-offwhite py-12 md:py-16" data-testid="section-faqs">
            <div className="max-w-[1200px] mx-auto px-6 md:px-10">
                <p className="font-manrope font-semibold text-terracotta text-[12px] tracking-[0.22em] uppercase mb-4">Answers to common questions</p>
                <h2 className="font-manrope font-bold text-charcoal text-[34px] md:text-[44px] leading-[1.05] tracking-tight mb-10 md:mb-14">Frequently asked questions</h2>
                <FAQAccordion items={items} testIdPrefix="home-faq" />
                <div className="mt-8">
                    <Link to="/faqs" className="font-inter text-terracotta hover:text-terracotta-600 underline-offset-4 hover:underline text-[15px] font-medium" data-testid="view-all-faqs-link">View all FAQs &rarr;</Link>
                </div>
            </div>
        </section>
    );
}
